import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Spinner from 'skrit-web-framework/components/Spinner.jsx';
import LoginForm from './loginForm.jsx';
import Svg from 'skrit-web-framework/components/Svg';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            loggedIn: false,
            loginErr: null
        };
    }

    renderMsg() {
        if (this.state.loginErr == null) return null;
        return (
            <div className='lock-message'>
                <span>{this.state.loginErr}</span>
            </div>
        );
    }

    render() {
        if (this.state.loggedIn) return <Redirect to='/' />;
        return (
            <div className='lock-screen'>
                <div className='row h-100'>
                    <div className='col-12 col-md-6 left-side'>
                        <Svg
                            color='#343a40'
                            src='/Styles/img/logo.svg'
                            class='svg logo'
                        />
                        <div className='title'>MOTOSCAT</div>
                        {window.innerWidth > 425 && (
                            <div className='intro'>
                                Programa para la búsqueda de artículos de
                                Motoscat
                            </div>
                        )}
                    </div>
                    <div className='col-12 col-md-6 right-side'>
                        <LoginForm
                            toggleIsFetching={value => {
                                this.setState({ isFetching: value });
                            }}
                            toggleLoggedIn={value => {
                                this.setState({
                                    loggedIn: value,
                                    isFetching: false
                                });
                            }}
                            toggleLoginErr={value => {
                                this.setState({
                                    loginErr: value,
                                    isFetching: false
                                });
                            }}
                            match={this.props.match}
                        />
                        {this.renderMsg()}
                    </div>
                </div>

                {this.state.isFetching && (
                    <Spinner
                        fullscreen
                        size='120px'
                        label='Cargando dashboard'
                    />
                )}
            </div>
        );
    }
}

export default Login;
